import { ChevronUp, Home } from "lucide-react";
import { Button } from "../../button/button";

type Props = {
  currentPath?: string;
  canGoUp: boolean;
  isLoading: boolean;
  onGoUp: () => void;
  onGoHome: () => void;
};

export const DirectoryNav = ({ currentPath, canGoUp, isLoading, onGoUp, onGoHome }: Props) => (
  <div className="flex items-center gap-2 border-b bg-white p-3">
    <Button
      variant="ghost"
      size="icon_md"
      onClick={onGoUp}
      disabled={!canGoUp || isLoading}
      className="h-9 w-9 shrink-0"
      title="Go Up"
      aria-label="Go Up"
    >
      <ChevronUp className="h-5 w-5" />
    </Button>
    <Button
      variant="ghost"
      size="icon_md"
      onClick={onGoHome}
      disabled={isLoading}
      className="h-9 w-9 shrink-0"
      title="Go to Default Folder"
      aria-label="Go to Default Folder"
    >
      <Home className="h-4 w-4" />
    </Button>
    <div
      className="flex-1 truncate rounded border bg-gray-100 px-3 py-2 font-mono text-xs text-gray-600"
      title={currentPath}
    >
      {currentPath ?? (isLoading ? "Loading..." : "")}
    </div>
  </div>
);
